import { render, staticRenderFns } from "./RelateBankMovements.vue?vue&type=template&id=b31494ba&scoped=true&"
import script from "./RelateBankMovements.vue?vue&type=script&lang=js&"
export * from "./RelateBankMovements.vue?vue&type=script&lang=js&"
import style0 from "./RelateBankMovements.vue?vue&type=style&index=0&id=b31494ba&prod&lang=scss&scoped=true&"
import style1 from "./RelateBankMovements.vue?vue&type=style&index=1&id=b31494ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31494ba",
  null
  
)

export default component.exports